<template>
  <div>
    <Toolbar ref="toolbar" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor
      ref="editor"
      id="editor"
      class="editor"
      :style="{ minHeight: '500px', overflowY: 'auto', backgroundColor: 'white', ...editorStyle }"
      v-model="html"
      :defaultConfig="editorConfig"
      :mode="mode"
      :readOnly="readOnly"
      @onChange="onChange"
      @onCreated="onCreated"
      @customPaste="(editor, event) => this.pasteText(editor, event)"
    />
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { getFileAccessHttpUrl, uploadAction } from '@/api/manage'

export default {
  name: 'WangEditor',
  components: { Editor, Toolbar },
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: '',
    },
    /* 高度 */
    height: {
      type: Number,
      default: null,
    },
    /* 最小高度 */
    minHeight: {
      type: Number,
      default: null,
    },
    /* 只读 */
    readOnly: {
      type: Boolean,
      default: false,
    },
    // 上传文件大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    /* 类型（base64格式、url格式） */
    type: {
      type: String,
      default: 'url',
    },
    editorStyle: {
      type: Object,
      default: () => ({
        minHeight: '200px',
        maxHeight: '500px',
      }),
    },
  },
  data() {
    return {
      editor: null,
      html: '<p></p>',
      currentValue: '',
      // 工具栏配置（注意结构，否则不起作用）
      toolbarConfig: {
        // 排除全屏按钮
        excludeKeys: ['todo', 'codeBlock', 'fullScreen'],
      },
      // 菜单配置（注意结构，否则不起作用）
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            // 自定义上传图片 方法
            customUpload: this.uploadImg,
            // 上传接口设置文件名
            fieldName: 'file',
          },
          uploadVideo: {
            customUpload: this.uploadVideo,
            fieldName: 'file',
          },
        },
      },
      mode: 'default', // or 'simple'
      base64Zip: '',
      // 图片、视频上传服务器地址
      uploadFileUrl: window._CONFIG['domianURL'] + '/sys/common/upload',
      base64uploadFileUrl: ``,
      httpuploadFileUrl: ``,
    }
  },
  watch: {
    // 监听父组件中editor值的变化
    value: {
      handler(val) {
        this.html = val
        this.currentValue = val
      },
      immediate: true,
    },
    // 监听外部传入的 readOnly 变化，并更新编辑器状态
    readOnly(newVal) {
      if (this.editor) {
        // 根据 newVal 调用编辑器启用或禁用 API
        if (newVal) {
          this.editor.disable()
        } else {
          this.editor.enable()
        }
      }
    },
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    setTimeout(() => {
      if (this.currentValue) {
        this.html = this.currentValue
      }
      // 查看菜单配置项
      // console.log(this.editor.getConfig());
      // const toolbar = DomEditor.getToolbar(this.editor)
      // const curToolbarConfig = toolbar.getConfig()
      // console.log( curToolbarConfig.toolbarKeys ) // 当前菜单排序和分组
    }, 1500)
  },
  methods: {
    onCreated(editor) {
      // 一定要用 Object.seal() ，否则会报错
      this.editor = Object.seal(editor)
      if (this.editor.config) {
        this.editor.config.linkModal = {
          appendToBody: true, // 将弹框挂载到 body 下
          offsetTop: 10, // 微调弹框垂直位置
          zIndex: 10000, // 确保弹框层级最高
        }
      }
      // 编辑器创建后，根据当前的 readOnly 属性设置编辑器状态
      if (this.readOnly) {
        this.editor.disable()
      }
    },
    onChange(editor) {
      this.$emit('input', this.html)
    },
    //自定义上传图片
    uploadImg(file, insertFn) {
      this.uploadFile(file, insertFn)
    },
    //自定义上传视频
    uploadVideo(file, insertFn) {
      this.uploadFile(file, insertFn, '视频')
    },
    // 上传文件
    uploadFile(file, successFn, text = '图片') {
      let formData = new FormData()
      formData.append('file', file)
      uploadAction(this.uploadFileUrl, formData)
        .then((res) => {
          if (res.success) {
            // 插入后端返回的url，将图片显示在页面上
            const img = getFileAccessHttpUrl(res.message)
            successFn(img)
            this.$message.success(text + '上传成功')
          } else {
            this.$message.error(text + '上传失败')
          }
        })
        .catch((err) => {
          this.$message.error(text + '上传失败')
        })
    },

    compressImg(base64, multiple) {
      return new Promise((resolve) => {
        // 第一个参数就是需要加密的base65，
        // 第二个是压缩系数 0-1，
        // 第三个压缩后的回调 用来获取处理后的 base64
        if (!base64) {
          return
        }
        // const _this = this
        const length = base64.length / 1024
        // 压缩方法
        let newImage = new Image()
        let quality = 0.6 // 压缩系数0-1之间
        newImage.src = base64
        newImage.setAttribute('crossOrigin', 'Anonymous') // url为外域时需要
        let imgWidth, imgHeight
        let w = undefined
        let smallBase64
        newImage.onload = function () {
          // 这里面的 this 指向 newImage
          // 通过改变图片宽高来实现压缩
          w = this.width * multiple
          imgWidth = this.width
          imgHeight = this.height
          let canvas = document.createElement('canvas')
          let ctx = canvas.getContext('2d')
          if (Math.max(imgWidth, imgHeight) > w) {
            if (imgWidth > imgHeight) {
              canvas.width = w
              // 等比例缩小
              canvas.height = w * (imgHeight / imgWidth)
            } else {
              canvas.height = w
              // 等比例缩小
              canvas.width = w * (imgWidth / imgHeight)
            }
          } else {
            canvas.width = imgWidth
            canvas.height = imgHeight
            // quality 设置转换为base64编码后图片的质量，取值范围为0-1  没什么压缩效果
            // 还是得通过设置 canvas 的宽高来压缩
            quality = 0.6
          }
          ctx.clearRect(0, 0, canvas.width, canvas.height)
          ctx.drawImage(this, 0, 0, canvas.width, canvas.height) //  // 这里面的 this 指向 newImage
          smallBase64 = canvas.toDataURL('image/jpeg', quality) // 压缩语句
          // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
          // while (smallBase64.length / 1024 > 150) {
          // quality -= 0.01;
          // smallBase64 = canvas.toDataURL("image/jpeg", quality);
          // }
          // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
          // while (smallBase64.length / 1024 < 50) {
          // quality += 0.001;
          // smallBase64 = canvas.toDataURL("image/jpeg", quality);
          // }

          // 必须通过回调函数返回，否则无法及时拿到该值，回调函数异步执行
          console.log(`压缩前：${length}KB`)
          console.log(`压缩后：${smallBase64.length / 1024} KB`)
          console.log(smallBase64, 'smallBase64')
          // this.base64Zip = smallBase64
          // await useImg(smallBase64, targetObj)
          resolve(smallBase64)
        }
      })
    },
    // useImg(base64, targetObj) {
    //   // targetObj 通过值引用的特性  用处理后的 base64 覆盖 处理前的 base63
    //   console.log('压缩后的 base64 :', base64)
    //   targetObj.src = base64
    //   return targetObj.src
    //   // this.base64Zip = base64
    // },

    /**
     * 从html代码中匹配返回图片标签img的属性src的值的集合
     * @param htmlData
     * @return Array
     */
    findAllImgSrcsFromHtml(htmlData) {
      let imgReg = /<img.*?(?:>|\/>)/gi //匹配图片中的img标签
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i // 匹配图片中的src

      let arr = htmlData.match(imgReg) //筛选出所有的img
      if (!arr || (Array.isArray(arr) && !arr.length)) {
        return false
      }

      let srcArr = []
      for (let i = 0; i < arr.length; i++) {
        let src = arr[i].match(srcReg)
        // 获取图片地址
        srcArr.push(src[1])
      }

      return srcArr
    },

    /**
     * 从rtf内容中匹配返回图片数据的集合
     * @param rtfData
     * @return Array
     */
    extractImageDataFromRtf(rtfData) {
      if (!rtfData) {
        return []
      }

      const regexPictureHeader = /{\\pict[\s\S]+?({\\\*\\blipuid\s?[\da-fA-F]+)[\s}]*/
      const regexPicture = new RegExp(
        '(?:(' + regexPictureHeader.source + '))([\\da-fA-F\\s]+)\\}',
        'g'
      )
      const images = rtfData && rtfData.match(regexPicture)
      const result = []
      if (images) {
        for (const image of images) {
          let imageType = false
          if (image.includes('\\pngblip')) {
            imageType = 'image/png'
          } else if (image.includes('\\jpegblip')) {
            imageType = 'image/jpeg'
          }
          if (imageType) {
            result.push({
              hex: image.replace(regexPictureHeader, '').replace(/[^\da-fA-F]/g, ''),
              type: imageType,
            })
          }
        }
      }

      return result
    },
    /**
     * 将html内容中img标签的属性值替换
     * @param htmlData html内容
     * @param imageSrcs html中img的属性src的值的集合
     * @param imagesHexSources rtf中图片数据的集合，与html内容中的img标签对应
     * @param isBase64Data 是否是Base64的图片数据
     * @return String
     */
    async replaceImgKeys(htmlData, imageSrcs, imagesHexSources, isBase64Data) {
      // return new Promise((resolve, reject) => {
      if (imageSrcs.length === imagesHexSources.length) {
        for (let i = 0; i < imageSrcs.length; i++) {
          let newSrc = isBase64Data
            ? `data:${imagesHexSources[i].type};base64,${this._convertHexToBase64(
                imagesHexSources[i].hex
              )}`
            : imagesHexSources[i]

          let resImg
          console.log('newSrc', newSrc.length / 1024 > 50)
          if (newSrc.includes(';base64,')) {
            resImg = await this.compressImg(newSrc, 0.8)
            console.log('resImg', resImg)
          }
          let formData = new FormData()
          if (newSrc.includes(';base64,')) {
            formData.append('file', resImg)
          } else {
            formData.append('file', newSrc)
          }
          uploadAction(this.uploadFileUrl, formData)
            .then((res) => {
              console.log(res.data, 'data')
              if (res.success) {
                // 插入后端返回的url，将图片显示在页面上
                console.log('复制粘贴图片：', res)
                const fileUrl = getFileAccessHttpUrl(res.message)
                insertFn(fileUrl)
                this.$message.success('图片上传成功')
                htmlData = htmlData.replace(imageSrcs[i], fileUrl)
              } else {
                this.$message.error('图片上传失败')
              }
            })
            .catch((err) => {
              this.$message.error('图片上传失败')
            })
        }
      }
      return htmlData
      // })
    },

    /**
     * 十六进制转base64
     */
    _convertHexToBase64(hexString) {
      return btoa(
        hexString
          .match(/\w{2}/g)
          .map((char) => {
            return String.fromCharCode(parseInt(char, 16))
          })
          .join('')
      )
    },
    // 自定义粘贴
    async pasteText(editor, event) {
      // 获取粘贴的html部分（？？没错粘贴word时候，一部分内容就是html），该部分包含了图片img标签
      let html = event.clipboardData.getData('text/html')

      // 获取rtf数据（从word、wps复制粘贴时有），复制粘贴过程中图片的数据就保存在rtf中
      const rtf = event.clipboardData.getData('text/rtf')
      console.log('rtf', rtf, html, 'html')
      if (html) {
        // 该条件分支即表示要自定义word粘贴
        // 列表缩进会超出边框，直接过滤掉
        html = html.replace(/text\-indent:\-(.*?)pt/gi, '')

        // 从html内容中查找粘贴内容中是否有图片元素，并返回img标签的属性src值的集合
        const imgSrcs = this.findAllImgSrcsFromHtml(html)

        // 如果有
        if (imgSrcs && Array.isArray(imgSrcs) && imgSrcs.length) {
          // word粘贴时从rtf内容中查找图片数据，网页粘贴过来的rtf是空的
          const rtfImageData = rtf ? this.extractImageDataFromRtf(rtf) : imgSrcs

          // 如果找到
          if (rtfImageData.length) {
            // TODO：此处可以将图片上传到自己的服务器上

            // 执行替换：将html内容中的img标签的src替换成ref中的图片数据，如果上面上传了则为图片路径
            this.replaceImgKeys(html, imgSrcs, rtfImageData, rtf ? true : false).then((res) => {
              html = res
              editor.dangerouslyInsertHtml(html)
              console.log('html', html)
            })
          }
          // 阻止默认的粘贴行为
          event.preventDefault()
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped lang="less">
/deep/ .w-e-modal {
  position: relative;
  z-index: 9999;

  button {
    line-height: 10px !important;
  }
}
</style>
